'use client';

import { Fragment, useEffect } from 'react';
import logoBigSrc from '@/public/assets/logo-big.png';

// CAROUSEL
import 'keen-slider/keen-slider.min.css';
import { useKeenSlider } from 'keen-slider/react';

// LODASH
import map from 'lodash/map';

// STYLES
import styles from './MainBanner.module.scss';

import Image from 'grandus-lib/components-atomic/image/Image';

import dynamic from 'next/dynamic';
import Link from 'next/link';
import TagManager from 'grandus-lib/utils/gtag';
import EnhancedEcommerce from '@/utils/ecommerce';
import { useRouter } from 'next/navigation';
import { getImageUrl } from '@/grandus-lib/utils';
import Carousel from '@/components/carousels/Carousel';
import Button from '@/components/_other/button/Button';
import ArrowUpRight from '@/components/_other/icons/ArrowUpRight';
import NextImage from 'next/image';


const BannerContent = ({ banner, imageProps }) => {
  return (
      <div
        className={styles?.desktop}
        style={{
          backgroundImage: `url(${getImageUrl(banner?.photo, '1500x930__cropped@2x', 'jpg')})`,
        }}
      >
        <div className="container relative">
          <div className="absolute bottom-12 lg:bottom-32 left-12 lg:left-20 flex flex-col items-center lg:items-start text-center lg:text-left gap-y-3 text-white">
            {banner.subtitle && <span>{banner?.subtitle}</span>}
            {banner.title && <h2 className="text-5xl font-normal leading-tight" dangerouslySetInnerHTML={{ __html: banner?.title }} />}
            {banner.url && <Button type='ghost' className="flex mt-32 lg:mt-0"><span dangerouslySetInnerHTML={{ __html: banner?.text}} className="[&>p]:m-0" /> <ArrowUpRight className="ml-5" /></Button>}
          </div>
        </div>
      </div>
  );
};

const MainBanner = ({ banners }) => {
  const router = useRouter();

  useEffect(() => {
    TagManager.push(EnhancedEcommerce.view_promotion(banners, 'main banners'));
  }, [banners]);


  return (
    <Carousel className={styles.slider}>
      {map(banners, (banner, index) => {
        const imageProps = {
          priority: index === 0,
        };

        if (!banner?.photo) {
          return '';
        }

        return (
          <Fragment key={`carousel-banners-main-${banner?.id}-${index}`}>
            <div className="flex items-center justify-center absolute top-[30%] lg:hidden w-full">
              <Link href={'/'} className={'w-[75%]'}>
                <NextImage
                  src={logoBigSrc}
                  alt={''}
                  className={
                    'mx-auto animate-flip-in will-change-transform [backface-visibility:hidden] '
                  }
                />
              </Link>
            </div>
            {banner.url ? (
              <Link
                href={banner.url}
                onClick={e => {
                  e.preventDefault();
                  TagManager.push(
                    EnhancedEcommerce.select_promotion(
                      banner,
                      'main banners',
                    ),
                    () => {
                      router.push(banner.url);
                    },
                  );
                }}
              >
                <BannerContent banner={banner} imageProps={imageProps} />
              </Link>
            ) : (
              <BannerContent banner={banner} imageProps={imageProps} />
            )}
          </Fragment>
        );
      })}
    </Carousel>
  );
};

export default MainBanner;
